<template>
  <div :class="wrapperClass" class="lazy-image">
    <v-skeleton-loader
      v-if="isLoading"
      :loading="isLoading"
      min-width="100%"
      type="card-avatar"
      class="lazy-image__loader"
    ></v-skeleton-loader>
    <v-img
      v-if="src"
      :src="src"
      :lazy-src="fallback"
      :alt="alt"
      @loadstart="handleLoadStart"
      @load="handleLoad"
      :class="imgClass"
      class="lazy-image__image"
    >
      <template v-slot:placeholder>
        <v-skeleton-loader
          :loading="true"
          min-width="100%"
          type="card-avatar"
        ></v-skeleton-loader>
      </template>
    </v-img>
    <v-img v-else class="lazy-image__image" :alt="alt" :src="fallback" />
  </div>
</template>

<script>
export default {
  name: 'LazyImage',
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    fallback: {
      type: String,
      default: require('@/assets/placeholder96x96.png'),
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    imgClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    handleLoadStart() {
      this.isLoading = true
    },
    handleLoad() {
      this.isLoading = false
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.lazy-image {
  position: relative;

  &__loader {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  img {
    position: relative;
  }
}
</style>
